import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEmpty, map } from 'ramda'
import { Flex, InlineAlert } from '@driftt/dds'
import { A, Button, Div, Input, Span, ToolTip } from '@driftt/tide-core'
import { createStaticSegment, addToMemberList } from 'api/segments'
import Config from 'config'
import cx from 'classnames'
import { getContactToEnroll } from 'api/contacts'
import { generateQueryString } from 'utils'
import { deselectMember } from 'modules/segment_list/actions'
import { intComma, pluralize } from 'humanize-plus'
import { integrationStatus, access } from '@driftt/traffic-control'

import StaticSegmentModal from 'components/Contacts/ContactControls/StaticSegmentModal'

import './style.css'
import { getSegmentTypeDisplayName } from 'components/Segments/constants/SegmentTypes';
import { generateContactsWebAppConfig } from '@driftt/app-config'

const mapStateToProps = state => ({
  segment: state.__CRM.segmentList.segment,
  selectedMembers: state.__CRM.segmentList.selectedMembers,
  appConfig: generateContactsWebAppConfig(state.user),
})

const mapDispatchToProps = dispatch => {
  return {
    onDeselectMembers: members => {
      dispatch(deselectMember(members))
    }
  }
}

class SegmentListControls extends Component {
  constructor(props) {
    super(props)

    this.state = {
      staticModalOpen: false,
      showSequenceEnroll: false,
      isOutreachConnected: integrationStatus.isIntegrationConnected('outreach')
    }
  }

  messageEventHandler = (event) => {
    const frame = document.getElementById("segment-sequence-enroll-frame")

     if (event.source !== frame && !event.data.type) {
       return
     }
     if (event.data.type ==='@@driftext/hide_enroll_modal' ) {
       this.setState({
         showSequenceEnroll: false
       })
     }
  }

  componentDidMount() {
    window.addEventListener('message', this.messageEventHandler, false)
  }

  componendWillUnmount() {
    window.removeEventListener('message', this.messageEventHandler, false)
  }

  toggleStaticModal = () => {
    this.setState(prevState => ({
      staticModalOpen: !prevState.staticModalOpen
    }))
  }

  saveAsNewStaticSegment = async (name) => {
    const { selectedMembers } = this.props

    const staticSegment = {
      type: 'ID_LIST',
      name
    }

    try {
      const { data } = await createStaticSegment(staticSegment)

      await addToMemberList(selectedMembers, data.id)

    } catch(e) {
      console.log(e)
    }
  }

  addToExistingSegment = async (id) => {
    const { selectedMembers } = this.props

    try {
      await addToMemberList(selectedMembers, id)

    } catch(e) {
      console.log(e)
    }
  }

  enrollInSequence = async () => {
    const { selectedMembers } = this.props

    try {
      const { data } = await getContactToEnroll(selectedMembers)

      const grabEmail = (contact) => {
        const { email } = contact
        return encodeURIComponent(email)
      }

      const emails = map(grabEmail, data)

      const generatedQueryString = generateQueryString(emails, 'email').join('')

      this.setState({
        showSequenceEnroll: true,
        emailArray: generatedQueryString + "&source=CRM"
      })
    } catch(e) {
      console.warn(e)
    }
  }

  renderViewFilterControls = () => {
    const { segment, onViewFilter } = this.props

    if (segment.type === 'ID_LIST') return null

    if (segment.type === 'MARKETO') {
      return (
        <A href="/contacts/imports/logs" target="_blank" className="single-segment--controls--view-info">View Marketo Logs</A>
      )
    }

    if (segment.type === 'PARDOT') {
      return null
    }

    return (
      <span onClick={onViewFilter} className="single-segment--controls--view-info">View Filter</span>
    )
  }

  renderSegmentInfo = () => {
    const {
      isEntirePageSelected,
      isPartiallySelected,
      onSelectAll,
      segment,
      selectedMembers,
      totalMembers,
    } = this.props

    const contactsAreSelected = !isEmpty(selectedMembers)

    const contactsInfo = (
      <Span>{intComma(totalMembers)} contacts</Span>
    )

    const selectedContactsInfo = (
      <Span>{selectedMembers.length} {pluralize(selectedMembers.length, "contact")} selected</Span>
    )

    const segmentInfo = (
      <span className="single-segment--controls--segment-type-wrapper">
        <span className="single-segment--controls--segment-type">
          {getSegmentTypeDisplayName(segment.type)} segment
        </span>
        {this.renderViewFilterControls()}
      </span>
    )

    const checked = isPartiallySelected || isEntirePageSelected

    const checkboxClassName = cx({
      'single-segment--controls--checkbox--indeterminate': isPartiallySelected && !isEntirePageSelected
    })

    return (
      <Div className="single-segment--controls--info">
        <Div className="single-segment--controls--info--select-all">
          <Input type="checkbox" checked={checked} onChange={onSelectAll} className={checkboxClassName} />
        </Div>
        {!contactsAreSelected && contactsInfo}
        {contactsAreSelected && selectedContactsInfo}
        {segmentInfo}
      </Div>
    )
  }

  renderSegmentActions = () => {
    const { onSearch, searchQuery, segment, selectedMembers, isLegacy } = this.props

    const searchEnabled = segment.type !== 'MARKETO' && segment.type !== 'PARDOT'
    const contactsAreSelected = !isEmpty(selectedMembers)

    return (
      <Div className="single-segment--controls--actions">
        {contactsAreSelected && this.renderSelectedControls()}
        {searchEnabled &&
          <ToolTip component={'Searches for contact name or email'} flow="up">
            <Input className="single-segment--controls--search" type="search" value={searchQuery} onChange={(event) => onSearch(event.target.value)} placeholder={'Search segment contacts'} disabled={!isLegacy} />
          </ToolTip>
        }
      </Div>
    )
  }

  renderSelectedControls = () => {
    const { selectedMembers, appConfig: { hasEnrollInSequence } } = this.props
    const { isOutreachConnected } = this.state
    const isActiveSalesSequenceOrg = access.hasGates('is_active_sales_sequence_org')

    const shouldShowEnrollInSequenceButton = hasEnrollInSequence && (isOutreachConnected || isActiveSalesSequenceOrg)

    const disableEnrollButton = isOutreachConnected && (selectedMembers.length > 1)

    return (
      <div className="single-segment--bulk-controls">
        <Button type="utility" onClick={this.toggleStaticModal} icon="donut-chart-2">
          Save static segment
        </Button>
        {shouldShowEnrollInSequenceButton && <Button type="utility" disabled={disableEnrollButton} onClick={this.enrollInSequence} icon="inbox-full">
          Enroll in sequence
        </Button>}
      </div>
    )
  }

  render() {
    const { selectedMembers, segmentTimedOut } = this.props
    const { staticModalOpen, showSequenceEnroll, emailArray } = this.state

    return (
      <Div className="single-segment--toolbar">
        { segmentTimedOut &&
          <Flex css={{ padding: '$2 $4' }}>
            <InlineAlert
              title="Member list cannot be shown due to session timeout"
              description="The segment is still available for use, but the member list is unavailable at this time. This timeout can happen when a segment has a lot of conditions that have to be evaluated in order to generate this list."
              variant="warning"
            />
          </Flex>
        }
        <Div className="single-segment--controls">
          {this.renderSegmentInfo()}
          {this.renderSegmentActions()}
        </Div>
        {staticModalOpen &&
          <StaticSegmentModal
            numberOfSelectedContacts={selectedMembers.length}
            open={staticModalOpen}
            onClose={this.toggleStaticModal}
            saveAsNew={this.saveAsNewStaticSegment}
            addToExisting={this.addToExistingSegment}
          />
        }
        {showSequenceEnroll &&
          <Div className="segment-sequence-enroll-wrapper">
            <Div className="segment-sequence-enroll">
              <iframe id="segment-sequence-enroll-frame" title="Enroll your sequence" src={`${Config.SEQUENCE_ENROLL}${emailArray}`} />
            </Div>
          </Div>
        }
      </Div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SegmentListControls)
